import { InputAdornment } from '@mui/material';

type TypeProps = {
  length: number;
};

export const Adotment = ({ length }: TypeProps) => {
  return (
    <InputAdornment
      position='end'
      sx={{
        position: 'absolute',
        left: `calc(${length * 8}px + 20px)`,
        color: 'grey',
      }}
    >
      - nothing found :(
    </InputAdornment>
  );
};
